export const exportSample = [
    { label: "TicketNo", key: "ticketNo" },
    { label: "TicketDate", key: "ticketDate" },
    { label: "CN", key: "cn" },
    { label: "CodAmount", key: "codAmount" },
    { label: "ConsigneeContact", key: "consigneeContact" },
    { label: "OrderRefNo", key: "orderRefNo" },
    { label: "BookingDate", key: "bookingDate" },
    { label: "DestinationBranch", key: "destinationBranch" },
    { label: "FailDeliveryReason", key: "pendingReason" },
    { label: "NSA/OSA Add. Charges", key: "nsa" },
    { label: "SubReason", key: "standardNote" },
    { label: "CallingStatus", key: "callStatus" },
    { label: "RemainingResponseTime", key: "kpi" },
    { label: "Status", key: "podStatus" },
    { label: "ShipperAdvice", key: "" },
    { label: "ActionRequired", key: "" },
    { label: "ConsigneePhoneNo", key: "" },
    { label: "ConsigneeAddress", key: "" },
    { label: "Remarks", key: "" },
  ];

